import React from 'react';

const DepartmentForm = ({ isOpen, onClose, onSubmit, formData, setFormData, isEditing, departments }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const renderTreeOptions = (parentId = null, level = 0) => {
        return departments
            .filter(d => d.ParentId === parentId && d.Id !== formData.Id)
            .map(d => (
                <React.Fragment key={d.Id}>
                    <option value={d.Id}>
                        {'\u00A0'.repeat(level * 4)}{level > 0 ? '˪ ' : ''}{d.Name}
                    </option>
                    {renderTreeOptions(d.Id, level + 1)}
                </React.Fragment>
            ));
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxWidth: '700px', maxHeight: '95vh', overflowY: 'auto' }}>

                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '15px', lineHeight: '1.4' }}>
                        {isEditing ? "Cập nhật đơn vị" : "Thêm mới đơn vị"}
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', display: 'flex', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="deptForm" onSubmit={onSubmit}>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Tên đơn vị *</label>
                            <input type="text" name="Name" className="form-input" value={formData.Name} onChange={handleChange} required />
                        </div>

                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Đơn vị cấp trên</label>
                            <select name="ParentId" className="form-input" value={formData.ParentId} onChange={handleChange}>
                                <option value="">Không có đơn vị cấp trên</option>
                                {renderTreeOptions(null, 0)}
                            </select>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <div className="form-group" style={{ flex: '1 1 250px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Người Quản lý/Liên hệ</label>
                                <input type="text" name="Manager" className="form-input" value={formData.Manager} onChange={handleChange} />
                            </div>
                            <div className="form-group" style={{ flex: '1 1 250px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Điện thoại/Email</label>
                                <input type="text" name="ContactInfo" className="form-input" value={formData.ContactInfo} onChange={handleChange} />
                            </div>
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="deptForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default DepartmentForm;